const timeAuctionContractAddress = "0x624bC5cCf85bc024a48F3F38836497fa1EAee6A2" // timed Auction

export default timeAuctionContractAddress